import { ReactNode } from 'react';

interface CourseMappingSmartCellBodyProps {
  value: ReactNode;
  otherValuesCount?: number;
}

const CourseMappingSmartCellBody = ({ value, otherValuesCount = 0 }: CourseMappingSmartCellBodyProps) => (
  <span className="course-mapping-smart-cell-body">
    <span className="course-mapping-smart-cell-value">{value}</span>
    {otherValuesCount > 0 ? (
      <span
        className="course-mapping-smart-cell-indicator"
        aria-label={`${otherValuesCount} other ${otherValuesCount === 1 ? 'value' : 'values'}`}
      >
        +{otherValuesCount}
      </span>
    ) : null}
  </span>
);

export default CourseMappingSmartCellBody;
